module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-3-8acb11c5300c6c7ae58f32b3f43a7fc0.webp";